export function InvoiceUnitSaleCtrl ($uibModalInstance, $scope, $translate, messages, workshopAPI, units) {

  $scope.stockNumber = '';
  $scope.units       = units;

  $scope.selectedItem = null;

  $scope.tableSettings = {
    columns: [
      {
        field : 'stock_number',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.STOCK_NUMBER')
        }
      },
      {
        field : 'is_new',
        header: {
          text: $translate.instant('DEALERSHIP_SPACE.CONDITION')
        },
        pipe: 'unitCondition'
      },
      {
        field : 'make',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        field : 'model',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        field : 'body_type',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BODY_TYPE')
        }
      },
      {
        field : 'build_date',
        header: {
          text: $translate.instant('VEHICLE_SPACE.BUILD_DATE')
        }
      },
      {
        field : 'odometer',
        header: {
          text: $translate.instant('VEHICLE_SPACE.ODOMETER')
        }
      },
      {
        field : 'group_or_franchise_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.FRANCHISE.GROUP_FRANCHISE')
        }
      },
      {
        classes: 'text-right',
        field  : 'suggested_sale_price',
        header : {
          classes: 'text-right',
          text   : $translate.instant('DEALERSHIP_SPACE.SUGGESTED_SALE_PRICE')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_UNITS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 5, 10, 25 ],
      queryCount: () => workshopAPI.post('/vehicles/for_sale_count', {})
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getUnits = ( params ) => {
    return workshopAPI.post('/vehicles/for_sale_index', {
      offset     : params.offset,
      page_size  : params.pageSize,
      sale_status: 'for_sale'
    })
    .then(units => {
      $scope.units = units;

      return units;
    });
  };

  $scope.onRowClick = function (event) {
    if (event.row.id) {
      if (event.row === $scope.selectedItem) {
        $scope.selectedItem = null;
      } else {
        $scope.selectedItem = event.row;
      }
    }
  };

  $scope.refresh = function () {
    $scope.filtered           = false;
    $scope.paging.currentPage = 1;
    $scope.stockNumber        = '';
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.acquisitions);
  };

  $scope.searchStock = function () {
    $scope.filtered = true;

    workshopAPI.get('/vehicle/find_by_stock_number', $scope.stockNumber)
      .then(function (data) {
        $scope.units = data && data !== 'null' ? [data]: [];
      }, function (error) {
        messages.error(error);
      });
  };

  $scope.selectUnit = function () {
    workshopAPI.get('/vehicle/sale_details', $scope.selectedItem.id)
      .then(function (data) {
        $uibModalInstance.close(data);
      }, function (error) {
        messages.error(error);
      });
  };
}